export {default as quadtree} from "./src/quadtree";



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-quadtree/index.js
// module id = ../../../../d3-quadtree/index.js
// module chunks = 4